import React from 'react';
import './chip.scss';

export const Chip: React.FC<any> = ({ key, label }) => (
  <div key={key} className="chip">
    <div className="chip-content">{label}</div>
  </div>
);
